import { CDN_BUCKET_URL } from '@/utils';

export const icons = {
  atc: `${CDN_BUCKET_URL}/dashboard/icon_atc.svg`,
  clock: `${CDN_BUCKET_URL}/dashboard/icon_clock.svg`,
  drivers: `${CDN_BUCKET_URL}/dashboard/icon_drivers.svg`,
  invoice: `${CDN_BUCKET_URL}/dashboard/icon_invoice.svg`,
  operations: `${CDN_BUCKET_URL}/dashboard/icon_operations.svg`,
  statusChange: `${CDN_BUCKET_URL}/dashboard/status_change_icon.svg`,
  routes: `${CDN_BUCKET_URL}/dashboard/icon_routes.svg`,
  vehicles: `${CDN_BUCKET_URL}/dashboard/icon_vehicles.svg`,
  sila: `${CDN_BUCKET_URL}/dashboard/icon_sila.svg`,
  tasks: `${CDN_BUCKET_URL}/dashboard/icon_tasks.svg`,
  preparePackage: `${CDN_BUCKET_URL}/dashboard/icon_prepare_package.svg`,
  attendTrack: `${CDN_BUCKET_URL}/dashboard/icon_attend_track.svg`,
  agenda: `${CDN_BUCKET_URL}/dashboard/icon_agenda.svg`,
  inbox: `${CDN_BUCKET_URL}/dashboard/icon_inbox.svg`,
  monitor: `${CDN_BUCKET_URL}/dashboard/icon_monitor.svg`,
  graphics: `${CDN_BUCKET_URL}/dashboard/icon_graphics.svg`,
  assignment: `${CDN_BUCKET_URL}/dashboard/icon_assignment.svg`,
  company: `${CDN_BUCKET_URL}/dashboard/icon_company.svg`,
  inventory: `${CDN_BUCKET_URL}/dashboard/icon_inventory.svg`,
  assignments: `${CDN_BUCKET_URL}/dashboard/icon_assignments.svg`,
  users: `${CDN_BUCKET_URL}/dashboard/icon_users.svg`,
  assets: `${CDN_BUCKET_URL}/dashboard/icon_assets.svg`,
  geography: `${CDN_BUCKET_URL}/dashboard/icon_geography.svg`,
  location: `${CDN_BUCKET_URL}/dashboard/icon_scaffolding_locations.svg`,
  region: `${CDN_BUCKET_URL}/dashboard/icon_regions.svg`,
  serviceHistory: `${CDN_BUCKET_URL}/dashboard/icon_service_history.svg`,
  request: `${CDN_BUCKET_URL}/dashboard/icon_request.svg`,
  departments: `${CDN_BUCKET_URL}/dashboard/icon_departments.svg`,
  city: `${CDN_BUCKET_URL}/dashboard/icon_city.svg`,
  cost: `${CDN_BUCKET_URL}/dashboard/icon_costs.svg`,
  logisticOperators: `${CDN_BUCKET_URL}/dashboard/icon_logistic_operators.svg`,
  commerces: `${CDN_BUCKET_URL}/dashboard/icon_commerces.svg`,
  settingsCatalogs: `${CDN_BUCKET_URL}/dashboard/icon_settings_catalogs.svg`,
  rendiciones: `${CDN_BUCKET_URL}/dashboard/icon_attend_track.svg`,
  meli: `${CDN_BUCKET_URL}/dashboard/icon_meli.svg`,
  scanGun: `${CDN_BUCKET_URL}/dashboard/icon_scan_gun.svg`,
};
